"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MillesRecovery = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MillesRecovery = function MillesRecovery(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MillesRecovery_svg__MillesRecovery_svg__clip0_17455_92228)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58 5.084h1.883l1.623 3.282 1.425-3.282h1.91v2.47h1.252v1.5H11.42v2.121h-1.5V7.908l-1.1 2.538a.75.75 0 01-1.36.034L6.08 7.693v3.482h-1.5v-2.12H3.328v-1.5H4.58v-2.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.063 14c3.288 0 5.953-2.686 5.953-6S11.35 2 8.063 2a5.94 5.94 0 00-5.106 2.913l.728.477c.44.29.318.735-.2.935l-2.568.977c-.415.153-.769-.072-.79-.518l-.12-2.749c-.025-.55.347-.83.777-.549l.51.335C2.689 1.529 5.199 0 8.063 0 12.446 0 16 3.582 16 8s-3.553 8-7.937 8a7.902 7.902 0 01-6.281-3.109c-.387-.503-.117-1.205.483-1.413.45-.156.941.025 1.247.39A5.921 5.921 0 008.062 14z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MillesRecovery_svg__MillesRecovery_svg__clip0_17455_92228"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.MillesRecovery = MillesRecovery;
var _default = MillesRecovery;
exports.default = _default;